import React, { useEffect, useState, useRef } from "react";
import { Formik, Form, Field } from "formik";
import isGHMC, { getCurrentDateTime, getStartOfCurrentDate } from "../../../../../Common/helper/helpar";
import { useFilterStore } from "../../../../AssetVehicle/store/useFilterStore";
import { useTripStore } from "../../store/useTripStore";
import { getNowDateTime, getOneMonthPastDateTime } from "../../../../AssetVehicle/utils/helpers";
import { AllOwnerTypeDetailsForSAT } from "../../../../../Apis/ownerTypeApi";
import { CorporationStore } from "../../../../corporation_master/CorporationStore";
import Select from "react-select";
export const ZoneWiseFilterForm = () => {
  const { fetchZoneWiseTrips } = useTripStore();
  const { fetchFilterOwnerTypes, ownerTypes } = useFilterStore();
  const { UserCorporations, fetchUserCorporations } = CorporationStore();
  const isProd = isGHMC();
  const hasInitialized = useRef(false);
  const [satOwnerTypes, setSatOwnerTypes] = useState([]);
  const currentDateTime = getCurrentDateTime();
  const currentDateWithStartTime = getStartOfCurrentDate();
  const [filters, setFilters] = useState(null);

  useEffect(() => {
    fetchFilterOwnerTypes();
    fetchUserCorporations();
  }, []);

  useEffect(() => {
    loadOwnerTypes();
  }, []);

  const loadOwnerTypes = async () => {
    try {
      const res = await AllOwnerTypeDetailsForSAT();
      if (res) {
        setSatOwnerTypes(res);
      }
    } catch (error) {
      console.error("Error fetching owner types:", error);
    }
  };


  useEffect(() => {
    if (ownerTypes.length > 0 && !hasInitialized.current) {
      hasInitialized.current = true;
      const storedFilters = JSON.parse(localStorage.getItem("sat-trips-zone-filters")) || {};
      const defaultFilters = {
        FromDateTime: storedFilters.FromDateTime || currentDateWithStartTime,
        ToDateTime: storedFilters.ToDateTime || currentDateTime,
        OwnerTypeId: storedFilters.OwnerTypeId || "", // Ensure OwnerTypeId is set
        CorporationId: storedFilters.CorporationId || [],
      };

      setFilters(defaultFilters);
      fetchZoneWiseTrips(defaultFilters);
      localStorage.setItem("sat-trips-zone-filters", JSON.stringify(defaultFilters));
    }
  }, [ownerTypes.length]); // Use ownerTypes.length instead of ownerTypes array

  const handleSubmit = (values) => {
    console.log(values);
    fetchZoneWiseTrips(values);
    localStorage.setItem("sat-trips-zone-filters", JSON.stringify(values));
  };

  const handleReset = (resetForm) => {
    const resetFilters = {
      FromDateTime: getStartOfCurrentDate(),
      ToDateTime: getCurrentDateTime(),
      OwnerTypeId: "",
      CorporationId: [],
    };

    resetForm({ values: resetFilters });

    // Update localStorage with reset filters
    localStorage.setItem("sat-trips-zone-filters", JSON.stringify(resetFilters));

    // Update state with reset filters
    setFilters(resetFilters);

    // Fetch API with reset filters
    fetchZoneWiseTrips(resetFilters);
  };


  if (!filters) return null; // Ensure filters are set before rendering the form

  return (
    <div>
      <Formik key={JSON.stringify(filters)} initialValues={filters} onSubmit={handleSubmit}>
        {({ values, resetForm, setFieldValue }) => (
          <Form>
            <div className="row d-flex align-items-center mt-3">
              <div className="col-md-2 mb-3">
                <div className="form-group">
                  <label className="form-label w-100 text-left">From Date</label>
                  <Field
                    type="datetime-local"
                    id="FromDateTime"
                    name="FromDateTime"
                    className="form-control"
                    min={getOneMonthPastDateTime()}
                    max={getNowDateTime()}
                  />
                </div>
              </div>
              <div className="col-md-2 mb-3">
                <div className="form-group">
                  <label className="form-label w-100 text-left">To Date</label>
                  <Field
                    type="datetime-local"
                    id="ToDateTime"
                    name="ToDateTime"
                    className="form-control"
                    min={values.FromDateTime}
                    max={currentDateTime}
                  />
                </div>
              </div>
              <div className="col-md-2 mb-3">
                <div className="form-group">
                  <label className="form-label w-100 text-left">Owner Type</label>
                  <Field as="select" name="OwnerTypeId" className="form-select">
                    <option value="">All</option>

                    {satOwnerTypes
                      .filter((type) => type.isActive)
                      .map((type) => (
                        <option
                          key={type.ownerTypeId}
                          value={type.ownerTypeId}
                        >
                          {type.ownerTypeName}
                        </option>
                      ))}
                  </Field>

                </div>
              </div>
              <div className="col-md-3 mb-3">
                <div className="form-group">
                  <label className="form-label w-100 text-left">Corporation</label>
                  <Select
                    inputId="zoneCorporationId"
                    isMulti
                    options={UserCorporations.map((corp) => ({
                      value: corp.corporationId,
                      label: corp.corporationName,
                    }))}
                    value={UserCorporations.filter((corp) =>
                      (values.CorporationId || []).includes(corp.corporationId)
                    ).map((corp) => ({
                      value: corp.corporationId,
                      label: corp.corporationName,
                    }))}
                    onChange={(selected) =>
                      setFieldValue("CorporationId", (selected || []).map((c) => c.value))
                    }
                    placeholder="Select Corporation(s)"
                    isClearable
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      control: (base) => ({
                        ...base,
                        borderRadius: "0px",
                        backgroundColor: "#ececec",
                        border: "1px solid #E2E2E2",
                        minHeight: "38px",
                      }),
                      placeholder: (base) => ({
                        ...base,
                        marginLeft: "6px",
                      }),
                      indicatorSeparator: (base) => ({
                        ...base,
                        backgroundColor: "#fff",
                      }),
                    }}
                  />
                </div>
              </div>
              <div className="col-md-3 ms-auto mb-4">
                <label className="form-label w-100">&nbsp;</label>
                <div className="d-flex gap-2">
                  <button
                    type="submit"
                    className={`btn ${isProd ? "search-ghmc" : "search-swm"}`}
                  >
                    Search
                  </button>
                  <button
                    type="reset"
                    className={`btn ${isProd ? "search-ghmc" : "search-swm"}`}
                    onClick={() => handleReset(resetForm)}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};
